import { render, staticRenderFns } from "./edit-transfer-popup.vue?vue&type=template&id=01f969a8&"
import script from "./edit-transfer-popup.vue?vue&type=script&lang=js&"
export * from "./edit-transfer-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports